import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import 'katex/dist/katex.min.css';
import './styles.css';
import { App } from './app/App';
import { simClient } from './simulation/client';
import { useApp } from './state/store';

simClient.start();
useApp.getState().init();
simClient.speed = useApp.getState().prefs.speed;

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
